document.addEventListener('DOMContentLoaded', () => {
  const lightbox = document.querySelector('[data-story-lightbox]');

  if (!lightbox) return;

  const lightboxImage = lightbox.querySelector('[data-story-lightbox-image]');
  const closeButton = lightbox.querySelector('[data-story-lightbox-close]');
  const triggers = document.querySelectorAll('[data-story-lightbox-trigger]');
  let activeTrigger;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const image = trigger.querySelector('img');

      activeTrigger = trigger;
      lightboxImage.src = image.currentSrc || image.src;
      lightboxImage.alt = image.alt;
      lightbox.showModal();
    });
  });

  closeButton.addEventListener('click', () => lightbox.close());

  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  lightbox.addEventListener('close', () => {
    lightboxImage.removeAttribute('src');
    lightboxImage.alt = '';
    activeTrigger?.focus();
  });
});
